import { z } from 'zod';

export const zodDeleteTaxCodeEndpointSchema = z.tuple([
  z.literal('tax_codes'),
  z.uuid(),
]);
